// src/pages/TermsOfService.js
import React from 'react';
import './TermsOfService.css'; 


const TermsOfService = () => {

  

  return (
    <div className="terms-container p-8 max-w-6xl mx-auto">
       
       <h1>InCall IQ Terms of Service</h1>
      <p className="last-updated">Last Updated: January 29, 2025</p>
    
    <div className="section">
        <h2>The Gist</h2>
        <p>Auxo Innovations Inc. ("InCall IQ", "we", "our", or "us") operates the InCall IQ call analytics platform, which we hope you (the "Customer", "you", or "your") find valuable. If you use it, please use it responsibly. If you don't, we'll have to terminate your account.</p>
        <p>You'll be charged monthly, and we'll automatically bill your credit card. You can cancel anytime with 30 days' notice, but we don't offer refunds for partial months or unused service. While our pricing can change, we'll always give you 90 days' notice before any changes take effect.</p>
        <p>You own your call recordings, transcripts, and business data. We'll keep it safe, compliant with HIPAA and GDPR, and available to you for up to 36 months.</p>
        <p>That's the basic idea, but you must read and agree to all the details below before using InCall IQ.</p>
    </div>
    
    <div className="section">
        <h2>1. The Service</h2>
        <h3>1.1 What We Provide</h3>
        <p>The "Service" means InCall IQ's call analytics platform, including:</p>
        <ul>
            <li>Call tracking and recording</li>
            <li>AI-powered transcription and analysis</li>
            <li>Business intelligence dashboard</li>
            <li>All related websites, APIs, and features</li>
        </ul>
        <h3>1.2 Service Evolution</h3>
        <ul>
            <li>We continuously improve the platform</li>
            <li>Features may be added or modified</li>
            <li>We'll notify you about significant changes</li>
            <li>Beta features may be available under separate terms</li>
        </ul>
    </div>
    
    <div className="section">
        <h2>2. Subscription and Payment</h2>
        <h3>2.1 Billing Terms</h3>
        <ul>
            <li>Service is billed monthly</li>
            <li>We automatically charge your credit card</li>
            <li>No refunds for partial months or unused service</li>
            <li>We may suspend service immediately if payment fails</li>
        </ul>
        <h3>2.2 Pricing Changes</h3>
        <ul>
            <li>90 days' notice before any price changes</li>
            <li>Changes apply at next billing cycle</li>
            <li>Legacy pricing may be discontinued</li>
            <li>Special pricing not guaranteed</li>
        </ul>
    </div>
    
    <div className="section">
        <h2>3. Data Management</h2>
        <h3>3.1 Data Retention</h3>
        <ul>
            <li>We retain call recordings and transcripts for up to 36 months</li>
            <li>After 36 months, older data is automatically purged</li>
            <li>Upon account termination, all your data is permanently deleted/li&gt;
            </li><li>You can request data deletion at any time via email</li>
        </ul>
        <h3>3.2 Your Data and Privacy</h3>
        <ul>
            <li>You own your call recordings and business data</li>
            <li>We maintain HIPAA and GDPR complianced</li>
            <li>We use industry-standard security</li>
            <li>We may use anonymized data to improve our service</li>
            <li>We never share identifiable customer data</li>
        </ul>
        <h3>3.3 Data Export</h3>
        <ul>
            <li>You can export your data at any time</li>
            <li>We provide standard export formats</li>
            <li>We'll assist with bulk exports upon request</li>
            <li>Exported data remains subject to these terms</li>
        </ul>
    </div>
    
    <div className="section">
        <h2>4. Intellectual Property</h2>
        <h3>4.1 What You Own</h3>
        <ul>
            <li>Your call recordings and transcripts</li>
            <li>Your business data and customer information</li>
            <li>Your customized dashboard configurations</li>
            <li>Your derived business insights</li>
        </ul>
        <h3>4.2 What We Own</h3>
        <ul>
            <li>The InCall IQ platform and technology</li>
            <li>Our AI models and algorithms</li>
            <li>Platform analytics and aggregated insights</li>
            <li>Our branding and documentation/li&gt;
        </li></ul>
    </div>
    
    <div className="section">
        <h2>5. Usage and Limits</h2> 
        <ul>
            <li>We currently don't impose strict usage limits</li>
            <li>We monitor usage patterns for fair use</li>
            <li>We'll communicate any new limits with advance notice</li>
            <li>We reserve the right to introduce limits as needed</li>
            <li>All limits will be clearly documented</li>
        </ul>
    </div>

    <div className="section">
        <h2>6. Compliance Requirements</h2>
        <h3>6.1 Your Responsibilities</h3> 
        <ul>
            <li>Inform all callers about call recordin</li>
            <li>Notify staff about call monitoring</li>
            <li>Obtain necessary consents</li>
            <li>Comply with local recording laws</li>
            <li>Maintain proper disclosures</li>
        </ul>

        <h3>6.2 Our Compliance</h3> 
        <ul>
            <li>Maintain HIPAA compliance</li>
            <li>Follow GDPR requirements</li>
            <li>Secure data transmission</li>
            <li>Regular security auditss</li>
            <li>Prompt breach notifications</li>
        </ul>
    </div>

    <div className="section">
        <h2>7. Integration Capabilities</h2> 
        <ul>
            <li>Third-party integrations available</li>
            <li>You're responsible for integration permission</li>
            <li>We're not liable for third-party services</li>
            <li>Data sharing follows your configuration</li>
            <li>Integration availability may change</li>
        </ul>
    </div>

    <div className="section">
        <h2>8. Support and Availability</h2>
        <h3>8.1 Support Policy</h3> 
        <ul>
            <li>We aim to respond within 24 hours</li>
            <li>Weekend responses may take longer</li>
            <li>Support via email and dashboard</li>
            <li>Policy subject to change with notice</li>
        </ul>

        <h3>8.2 System Availability</h3> 
        <ul>
            <li>We strive for maximum uptime</li>
            <li>Planned maintenance with notice</li>
            <li>Emergency maintenance when needed</li>
            <li>Status updates via our dashboard</li>
        </ul>
    </div>

    <div className="section">
        <h2>9. Critical Situations</h2>
        <h3>9.1 System Issues</h3> 
        <ul>
            <li>Prompt notification of major outages</li>
            <li>Regular status updates</li>
            <li>Clear resolution timelines</li>
            <li>Service credits as applicable</li>
        </ul>

        <h3>9.2 Security Incidents</h3> 
        <ul>
            <li>Immediate notification of breaches</li>
            <li>Details of affected data</li>
            <li>Steps taken to resolve</li>
            <li>Preventive measures implemented</li>
        </ul>
    </div>

    <div className="section">
        <h2>10. Account Terminations</h2>
        <h3>10.1 Your Rights</h3> 
        <ul>
            <li>Cancel anytime with 30 days' notic</li>
            <li>Export your data before termination</li>
            <li>Request data deletion</li>
            <li>Access to historical data ends/li&gt;
        </li></ul>

        <h3>10.2 Our Rights</h3> 
        <ul>
            <li>Suspend service for non-payment</li>
            <li>Terminate for terms violation</li>
            <li>Remove harmful or illegal content</li>
            <li>Deny service at our discretion</li>
        </ul>
    </div>

    <div className="section">
        <h2>11. Dispute Resolution</h2> 
        <ul>
            <li>All disputes resolved through binding arbitration</li>
            <li>Arbitration conducted in New York</li>
            <li>Class action waiver</li>
            <li>Each party bears its costs</li>
            <li>Either party can seek injunctive relief</li>
        </ul>
    </div>

    <div className="section">
        <h2>12. Liability and Warranty</h2> 
        <ul>
            <li>Service provided "as is"</li>
            <li>Not liable for business decisions</li>
            <li>Maximum liability limited to fees paid</li>
            <li>No warranty of uninterrupted service</li>
            <li>Force majeure applies</li>
        </ul>
    </div>

    <div className="section">
        <h2>13. General Terms</h2> 
        <ul>
            <li>You must be over 18 to use the service</li>
            <li>You must have authority to agree</li>
            <li>Terms may change without notice</li>
            <li>Invalid terms don't affect others</li>
            <li>New York law applies</li>
            <li>No assignment without permission</li>
        </ul>
    </div>
    
    <div className="section">
        <h2>Contact Us</h2> 
        <p>If you have questions or need assistance: <a href="mailto:hello@incalliq.com">hello@incalliq.com</a></p>  
    </div>

    <div className="section">
        <p>By using InCall IQ, you agree to these terms. We can change them anytime, and your continued use means you accept those changes.</p>
        <p>Last Updated: January 29, 2025</p>
    </div>


    </div>

    
  );
};


export default TermsOfService;
